import api from './index';
//
let exports = {};

// 获取配件定义列表
exports.getProjFolderTplJson = function (params, callback) {
    api.get('/json/proj-folder-tpl')
    .params(params)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/json.js
// module id = 2022
// module chunks = 0